/* Скрипт подарункового лендінга. Винесено з sections/gift-landing.liquid:
   74 КБ більше не їдуть у кожній сторінці, браузер бере їх із кешу.
   Тексти й ціни, які раніше підставляв Liquid, приходять із JSON-блоку
   [data-gl-json] у розмітці секції — тут вони читаються як D.<назва>. */
(function () {
  var box = document.querySelector('[data-gl-json]');
  var D = {};
  try { D = JSON.parse(box ? box.textContent : '{}') || {}; } catch (e) { D = {}; }

  var root = document.querySelector('[data-gl-root]');

  if (!root || root.dataset.glInit) return;
  root.dataset.glInit = '1';

  var q = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var qa = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

  /* ── Спільні гальма для всіх сцен ──
     onScroll — один цикл на кадр: прокрутку читаємо раз, далі кожна сцена
     малює своє. Досі на кожен рух пальцем працювало п'ять окремих
     обробників, і кожен ще й сам міряв геометрію — на дешевому телефоні
     кадр на це й ішов.
     onResize — коли на Android ховається панель адреси, приходить resize зі
     зміненою висотою. Перемірюватись на нього не можна: сцени стрибають.
     Реагуємо тільки на зміну ширини, поворот екрана її теж змінює.
     jumpTo — миттєвий зсув прокрутки: у каркасі стоїть scroll-behavior:
     smooth, і без цього програмна поправка їхала б плавно, тобто виглядала
     б як те саме смикання, від якого її додано. */
  var scrollFns = [], scrollTick = false, scrollAt = 0;
  var scrollPaint = function () {
    scrollTick = false;
    scrollAt = window.scrollY || window.pageYOffset || 0;
    frameWatch();
    for (var i = 0; i < scrollFns.length; i++) scrollFns[i](scrollAt);
  };
  var onScroll = function (fn) {
    scrollFns.push(fn);
    if (scrollFns.length > 1) return;
    window.addEventListener('scroll', function () {
      if (scrollTick) return;
      scrollTick = true;
      requestAnimationFrame(scrollPaint);
    }, { passive: true });
  };
  /* Висота екрана, на яку спираються закріплені сцени. Береться один раз і
     оновлюється лише при зміні ширини: якби вона йшла за vh, кожне
     приховування панелі адреси на телефоні міняло б висоту сцен — саме
     звідси характерне смикання вгору-вниз. */
  var setVH = function () { root.style.setProperty('--gl-vh', window.innerHeight + 'px'); };
  setVH();
  var winW = window.innerWidth, resizeFns = [setVH];
  var onResize = function (fn) { resizeFns.push(fn); };
  window.addEventListener('resize', function () {
    if (window.innerWidth === winW) return;
    winW = window.innerWidth;
    for (var i = 0; i < resizeFns.length; i++) resizeFns[i]();
  });
  var jumpTo = function (y) {
    var h = document.documentElement, was = h.style.scrollBehavior;
    h.style.scrollBehavior = 'auto';
    window.scrollTo(0, Math.max(0, y));
    h.style.scrollBehavior = was;
  };
  /* Висота документа міняється рідко — коли сцена згортає свою доріжку.
     Тим, хто на неї спирається, тоді треба перемірятись. */
  var docFns = [];
  var docChanged = function () { for (var i = 0; i < docFns.length; i++) docFns[i](); };

  /* ── Легкий режим ──
     Дешевий телефон не тягне закріплені сцени, блюри й безперервні
     анімації. Прості ознаки пристрою вже перевірено в ранньому скрипті
     (клас gl-lite ставиться до першого малювання) — але вони бувають
     недоступні, тому нижче ще й міряємо справжню довжину кадру під час
     прокрутки. Виявилось повільно — важке вимикається на ходу: кожна сцена
     лишає свій вимикач у liteOff. */
  var lite = root.classList.contains('gl-lite');
  var liteOff = [];
  var goLite = function () {
    if (lite) return;
    lite = true;
    root.classList.add('gl-lite');
    liteOff.forEach(function (fn) { try { fn(); } catch (e) {} });
  };
  /* ── Чи тягне пристрій ──
     Міряємо справжню довжину кадру під час прокрутки — але лише тоді,
     коли вона показова. Три випадки навмисно пропускаємо, бо кадри там
     важкі в будь-кого, і сторінка помилково вирішувала, що потрапила на
     дешевий телефон: у покупця раптом зникали переходи між сценами,
     анімація показувала всі елементи одразу, а фон ставав однаковим.

       · перші секунди після відкриття — сторінка ще вантажить картинки
         і шрифти (це ловилося, коли оновлюєш сторінку посеред неї);
       · плавна прокрутка, яку запустили ми самі — клік по пункту меню
         переганяє всю сторінку, і кожен такий кадр дорогий;
       · паузи між рухами пальця — це не повільний кадр, а просто пауза.

     УВАГА: сам вимір поки не ввімкнений — у налаштуваннях секції стоїть
     «Never», бо на дизайні він заважав: режим вмикався на здорових
     пристроях і ламав фон, анімацію та переходи. Числа нижче підібрані
     частково й потребують доведення.

     Що з'ясувалося замірами (09.10.2026) і що лишилося виправити:
       · сторінка тримає близько 17 мс на кадр навіть при процесорі,
         вповільненому ввосьмеро, — вона швидша, ніж здавалося;
       · головна вада логіки: що слабший пристрій, то МЕНШЕ кадрів
         устигає набратися (при ×8 їх лише 9), тож вибірка в кілька
         десятків кадрів на слабкому телефоні недосяжна в принципі.
         Рішення треба ухвалювати за часом спостереження або за часткою
         повільних кадрів, а не за фіксованою кількістю. */
  var liteAuto = root.dataset.glLite === 'auto';
  var LITE_FRAMES = 72;
  var LITE_SLOW_MS = 26;
  /* Стеля «це вже не кадр, а пауза». Було 100 мс — і саме під неї
     потрапляли найповільніші кадри дешевих телефонів: вони відсіювалися,
     вибірка не набиралася, і режим не вмикався там, де був потрібен.
     Пауза між рухами пальця триває секунди, тож 450 мс їх не зачіпає. */
  var LITE_PAUSE_MS = 450;
  var frN = 0, frT = 0, frLast = 0;
  /* до цієї позначки кадри не рахуємо */
  var frQuietUntil = Date.now() + 2500;
  var frHush = function (ms) { frQuietUntil = Math.max(frQuietUntil, Date.now() + ms); frN = 0; frT = 0; frLast = 0; };
  var frameWatch = function () {
    if (!liteAuto || lite || frN >= LITE_FRAMES) return;
    if (Date.now() < frQuietUntil) { frLast = 0; return; }
    var now = performance.now ? performance.now() : Date.now();
    var d = now - frLast;
    frLast = now;
    if (d <= 0 || d > LITE_PAUSE_MS) return;
    frT += d;
    if (++frN >= LITE_FRAMES && frT / frN > LITE_SLOW_MS) goLite();
  };

  function track(event, props) {
    var p = Object.assign({ event: event }, props || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(p);
  }

  /* ── Мобільне меню (у макеті кнопка була без дії) ── */
  var burger = q('[data-gl-burger]');
  var mobnav = q('[data-gl-mobnav]');
  if (burger && mobnav) {
    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!open));
      mobnav.classList.toggle('is-open', !open);
    });
    qa('a', mobnav).forEach(function (a) {
      a.addEventListener('click', function () {
        burger.setAttribute('aria-expanded', 'false');
        mobnav.classList.remove('is-open');
      });
    });
  }

  /* ── Живий прев'ю картки ── */
  var state = {
    firstName: 'Bride',
    surname: '',
    yourName: '',
    message: D.defaultMessage,
    occasion: D.firstOccasion,
    /* Своя нагода з поля «Other». Порожньо — покупець обрав готовий чип. */
    occasionOwn: '',
    delivery: 'instant',
    nameTracked: false
  };
  var card = q('[data-gl-card]');
  var elCover = q('[data-gl-cover]');
  var elMessage = q('[data-gl-message]');
  var elFrom = q('[data-gl-from]');
  var elOccasion = q('[data-gl-occasion]');
  var defaultMessage = D.defaultMessage;

  function paintCard() {
    var first = state.firstName.trim();
    var last = state.surname.trim();
    elCover.textContent = last ? 'For the future Mrs. ' + last : (first ? 'For ' + first : 'For her');
    elMessage.textContent = state.message.trim() || defaultMessage;
    elFrom.textContent = state.yourName.trim() ? 'From ' + state.yourName.trim() : 'From someone who loves you';
    elOccasion.textContent = state.occasion;
    qa('[data-gl-name]').forEach(function (el) { el.textContent = first || 'Bride'; });
    /* Сцена «Як це працює» імені з форми не бере. Раніше брала, але лише
       в половині місць: три написи там друкуються по літерах, і кількість
       кроків анімації Liquid рахує на сервері за довжиною «Emma». Підміна
       тексту їх ламала, тож їх лишали як є — і виходило, що на картці
       одне ім'я, а на коробці інше. Тепер в усій сцені стоїть ім'я з
       налаштувань секції (типово Emma), і вона всюди однакова.
       Атрибути data-gl-hwname лишені: вони позначають ці місця, якщо
       колись вирішимо повернути підстановку разом із перерахунком кроків. */
    qa('[data-gl-initial]').forEach(function (el) { el.textContent = (first || 'Bride').charAt(0).toUpperCase(); });
  }

  /* Кнопки з її ім'ям — лише коли ім'я ввів сам покупець, не «Bride» за замовчуванням */
  var ctaLabel = D.ctaLabel;
  var ctaNamed = D.ctaNamed;
  function paintCtas() {
    var name = state.nameTouched ? state.firstName.trim() : '';
    var txt = name && ctaNamed ? ctaNamed.replace('{name}', name) : ctaLabel;
    qa('[data-gl-cta-label]').forEach(function (el) { el.textContent = txt; });
  }

  qa('[data-gl-input]').forEach(function (input) {
    input.addEventListener('input', function () {
      var key = input.dataset.glInput;
      state[key] = input.value;
      /* однакові поля (ім'я в hero і у формі) тримаються в парі */
      qa('[data-gl-input="' + key + '"]').forEach(function (o) { if (o !== input) o.value = input.value; });
      if (key === 'firstName') {
        state.nameTouched = true;
        paintCtas();
        if (!state.nameTracked && input.value.trim()) {
          state.nameTracked = true;
          track('recipient_name_entered');
        }
      }
      paintCard();
      saveDraft();
    });
  });

  /* ── Нагода ──
     Готові чипи плюс «Other» з власним полем. Вибір чипа ховає поле й
     повертає картці його підпис; «Other» відкриває поле й віддає картці
     те, що там написано. Поки поле порожнє, на картці лишається перша
     нагода зі списку — краще ніж порожнє місце. */
  var occOther = q('[data-gl-occ-other]');
  var occOwnBox = q('[data-gl-occ-own]');
  var occOwnInput = occOwnBox && q('input', occOwnBox);

  var occPress = function (btn) {
    qa('[data-gl-occ]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    if (occOther) {
      occOther.setAttribute('aria-pressed', btn === occOther ? 'true' : 'false');
      occOther.setAttribute('aria-expanded', btn === occOther ? 'true' : 'false');
    }
    if (btn && btn !== occOther) btn.setAttribute('aria-pressed', 'true');
    if (occOwnBox) occOwnBox.hidden = btn !== occOther;
  };

  qa('[data-gl-occ]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      occPress(btn);
      state.occasionOwn = '';
      state.occasion = btn.dataset.glOcc;
      paintCard();
      saveDraft();
    });
  });

  if (occOther && occOwnInput) {
    occOther.addEventListener('click', function () {
      occPress(occOther);
      occOwnInput.focus();
      /* показуємо вписане раніше, якщо воно є */
      state.occasion = occOwnInput.value.trim() || D.firstOccasion;
      paintCard();
      saveDraft();
    });
    occOwnInput.addEventListener('input', function () {
      var v = occOwnInput.value.trim();
      state.occasionOwn = v;
      state.occasion = v || D.firstOccasion;
      paintCard();
      saveDraft();
    });
  }

  /* ── Стиль картки ── */
  qa('[data-gl-style]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      qa('[data-gl-style]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      btn.setAttribute('aria-pressed', 'true');
      var d = btn.dataset;
      card.style.background = d.bg;
      card.style.borderColor = d.border;
      qa('[data-gl-ink]').forEach(function (el) { el.style.color = d.ink; });
      qa('[data-gl-accent]').forEach(function (el) { el.style.color = d.accent; });
      var b2 = q('[data-gl-border2]');
      if (b2) b2.style.borderTopColor = d.border2;
      var qr = q('[data-gl-qr]');
      if (qr) {
        qr.style.backgroundColor = d.ink;
        qr.style.backgroundImage = 'repeating-conic-gradient(' + d.bg + ' 0% 25%,transparent 0% 50%)';
      }
    });
  });
  var firstStyle = q('[data-gl-style]');
  if (firstStyle) firstStyle.click();

  /* ── Спосіб вручення і сума ── */
  var priceStr = D.price;
  var addonStr = D.addon;
  var priceNum = parseFloat(String(priceStr).replace(/[^0-9.]/g, ''));
  var addonNum = parseFloat(String(addonStr).replace(/[^0-9.]/g, '')) || 0;
  var symMatch = String(priceStr).match(/[^0-9.,\s]/);
  var sym = symMatch ? symMatch[0] : '$';
  var printedRow = q('[data-gl-printed-row]');
  var totalEls = qa('[data-gl-total],[data-gl-sticky-total]');

  qa('[data-gl-delivery]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      qa('[data-gl-delivery]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      btn.setAttribute('aria-pressed', 'true');
      state.delivery = btn.dataset.glDelivery;
      var printed = state.delivery === 'printed';
      if (printedRow) printedRow.hidden = !printed;
      var total = printed && !isNaN(priceNum) ? sym + (priceNum + addonNum).toFixed(0) : priceStr;
      totalEls.forEach(function (el) { el.textContent = total; });
      track('delivery_format_selected', { format: state.delivery });
    });
  });

  /* ── FAQ ── */
  qa('[data-gl-faq-q]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      qa('[data-gl-faq-q]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        b.querySelector('i').textContent = '+';
        b.parentNode.querySelector('.gl-faq-a').hidden = true;
      });
      if (!open) {
        btn.setAttribute('aria-expanded', 'true');
        btn.querySelector('i').textContent = '–';
        btn.parentNode.querySelector('.gl-faq-a').hidden = false;
      }
    });
  });

  /* ── Телефон у сцені «How it works»: ім'я, записка й підпис з форми ── */
  var revNameEl = q('[data-gl-rev-name]');
  var revMsgEl = q('[data-gl-rev-message]');
  var revFromEl = q('[data-gl-rev-from]');
  var revMsgFallback = D.revMsgFallback;

  function paintPhone() {
    if (revNameEl) revNameEl.textContent = state.firstName.trim() || 'Bride';
    if (revMsgEl) revMsgEl.textContent = '“' + (state.message.trim() || revMsgFallback) + '”';
    if (revFromEl) revFromEl.textContent = state.yourName.trim() ? 'From ' + state.yourName.trim() : 'From someone who loves you';
  }

  qa('[data-gl-input]').forEach(function (input) {
    input.addEventListener('input', paintPhone);
  });

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Переходи за якорями всередині сторінки ──
     Половина цілей лежить у закріплених сценах (position: sticky). Поки
     сторінка вгорі, звичайний перехід за href працює; але коли вона
     прокручена далеко, закріплений блок «прилипає», і позиція, яку
     бачить браузер, починає текти разом зі скролом. Ціль тікає рівно з
     тією ж швидкістю, з якою браузер до неї їде, — і сторінка зрушує
     на кілька сантиметрів і стає.

     Тому рахуємо позицію самі, ланцюжком offsetTop: він показує, де
     блок лежить у документі насправді, і на sticky не зважає. Відступ
     під липку шапку беремо зі scroll-margin-top самої цілі, щоб не
     розходитися зі стилями. */
  var anchorY = function (el) {
    /* Поки сцена «прилипла», браузер віддає її положення вже з поправкою
       на прилипання — і offsetTop, і rect. Заміряно: offsetTop тієї самої
       сцени дорівнює 0 вгорі сторінки і 6968 унизу. Тому на мить знімаємо
       закріплення з усіх предків, читаємо справжнє положення й одразу
       повертаємо як було. Усе в одному кадрі, тож оку це непомітно. */
    var stuck = [];
    var n = el;
    while (n && n !== document.body) {
      if (getComputedStyle(n).position === 'sticky') {
        stuck.push([n, n.style.position]);
        n.style.position = 'static';
      }
      n = n.parentElement;
    }
    var y = el.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
    for (var i = 0; i < stuck.length; i++) stuck[i][0].style.position = stuck[i][1];
    var pad = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
    return Math.max(0, Math.round(y - pad));
  };
  qa('a[href^="#"]', root).forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href').slice(1);
      if (!id || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      var top = id === 'top' ? 0 : anchorY(el);
      /* Поки сторінка сама їде через пів документа, кадри дорогі в
         будь-кого — на цей час вимір «чи тягне пристрій» мовчить. */
      frHush(1800);
      try {
        window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
      } catch (err) {
        window.scrollTo(0, top);
      }
    });
  });

  /* ── Ім'я в hero ──
     Поки поле порожнє й не в фокусі, у підказці самі друкуються приклади
     імен — видно, що сюди можна писати. Enter веде до форми. */
  var heroName = q('[data-gl-hero-name] input');
  if (heroName) {
    heroName.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      heroName.blur();
      var cta = q('[data-gl-cta="hero"]');
      if (cta) cta.click();
    });
    var examples = (heroName.dataset.glExamples || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    if (examples.length && !reduceMotion) {
      var basePh = heroName.placeholder, exI = 0, exCh = 0, exDir = 1;
      var typeStep = function () {
        var delay;
        if (document.activeElement === heroName || heroName.value) {
          heroName.placeholder = basePh;
          exCh = 0; exDir = 1;
          delay = 1500;
        } else {
          var word = examples[exI];
          exCh += exDir;
          heroName.placeholder = word.slice(0, exCh);
          delay = exDir > 0 ? 120 : 50;
          if (exDir > 0 && exCh >= word.length) { exDir = -1; delay = 1600; }
          else if (exDir < 0 && exCh <= 0) { exDir = 1; exI = (exI + 1) % examples.length; delay = 450; }
        }
        setTimeout(typeStep, delay);
      };
      setTimeout(typeStep, 1800);
    }
  }

  /* ── Як це працює: сцена з телефоном ──
     v10: п'ять кроків йдуть по колу самі, поки сцена хоч наполовину на екрані;
     крок із кількома екранами (open,note) гортає їх і стоїть довше.
     Клік по кроку — перейти до нього, далі цикл іде з нього. Тап по телефону:
     якщо кадр ще анімується — одразу готовий, інакше — наступний кадр (екран)
     одразу готовим; цикл після тапу чекає повний час кадру. Перлини
     зсуваються з прокруткою (--gl-sp — де сцена відносно екрана). */
  var story = q('[data-gl-story]');
  if (story) {
    var sSteps = qa('[data-gl-step]', story);
    var sScreens = qa('[data-gl-scr]', story);
    var sRail = q('[data-gl-story-rail]', story);
    var sDots = qa('.gl-sdots i', story);
    var sHeader = q('.gl-header');
    var sPin = q('[data-gl-story-pin]', story);
    var sCur = -1, sSub = 0, sShownAt = 0, sSubTimer = null, sLoop = null, sSeen = false, sTick = false;
    /* Кадри — кожен екран кожного кроку по черзі: [крок, екран] */
    var sFrames = [];
    sSteps.forEach(function (st, k) { st.dataset.glStep.split(',').forEach(function (n, j) { sFrames.push([k, j]); }); });
    var STEP_MS = 2300, SUB_MS = 1800;

    var headH = function () {
      return sHeader && getComputedStyle(sHeader).position === 'sticky' ? sHeader.offsetHeight : 0;
    };
    var showScr = function (name) {
      sShownAt = Date.now();
      sScreens.forEach(function (s) { s.classList.toggle('is-on', s.dataset.glScr === name); });
    };
    var calm = function () { story.classList.remove('is-instant'); };
    var paintStory = function (i, sub) {
      sCur = i;
      sSub = sub || 0;
      story.dataset.glAt = i;
      sSteps.forEach(function (s, k) {
        s.setAttribute('aria-current', String(k === i));
        s.classList.toggle('is-past', k < i);
      });
      sDots.forEach(function (d, k) { d.classList.toggle('is-on', k <= i); });
      if (sRail) sRail.style.transform = 'scaleY(' + ((i + 1) / sSteps.length) + ')';
      var list = sSteps[i].dataset.glStep.split(',');
      showScr(list[sSub]);
      clearInterval(sSubTimer);
      if (list.length > 1 && !reduceMotion) {
        sSubTimer = setInterval(function () { calm(); sSub = (sSub + 1) % list.length; showScr(list[sSub]); }, SUB_MS);
      }
    };
    /* Крок стоїть стільки, скільки йому треба, потім наступний; після останнього — знову перший */
    var storyNext = function () {
      clearTimeout(sLoop);
      if (!sSeen || reduceMotion) return;
      var list = sSteps[sCur].dataset.glStep.split(',');
      var wait = list.length > 1 ? (list.length - sSub) * SUB_MS + 400 : STEP_MS;
      sLoop = setTimeout(function () {
        calm();
        paintStory((sCur + 1) % sSteps.length);
        storyNext();
      }, wait);
    };
    var storyPar = function () {
      sTick = false;
      var r = story.getBoundingClientRect();
      var p = Math.min(Math.max((window.innerHeight - r.top) / (window.innerHeight + r.height), 0), 1);
      story.style.setProperty('--gl-sp', p.toFixed(3));
    };
    var setHead = function () { story.style.setProperty('--gl-hh', headH() + 'px'); };

    window.addEventListener('scroll', function () {
      if (!sTick) { sTick = true; requestAnimationFrame(storyPar); }
    }, { passive: true });
    window.addEventListener('resize', setHead);
    sSteps.forEach(function (s, k) {
      s.addEventListener('click', function () {
        calm();
        paintStory(k);
        storyNext();
      });
    });
    /* Тап по телефону: догнати кадр або показати наступний — без анімації */
    var sPhone = q('.gl-sphone', story);
    if (sPhone) {
      sPhone.addEventListener('click', function () {
        var list = sSteps[sCur].dataset.glStep.split(',');
        var busyMs = list[sSub] === 'done' ? 2100 : 800;
        var busy = !story.classList.contains('is-instant') && Date.now() - sShownAt < busyMs;
        story.classList.add('is-instant');
        if (!busy) {
          var f = 0;
          sFrames.forEach(function (fr, k) { if (fr[0] === sCur && fr[1] === sSub) f = k; });
          var nf = sFrames[(f + 1) % sFrames.length];
          paintStory(nf[0], nf[1]);
        }
        /* Перезапуск екрана при вимкнених переходах — він одразу в кінцевому стані */
        var on = q('.gl-scr.is-on', story);
        if (on) {
          on.classList.remove('is-on');
          void on.offsetWidth;
          on.classList.add('is-on');
          void on.offsetWidth;
        }
        storyNext();
        track('story_tap', { step: sCur + 1 });
      });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var was = sSeen;
        sSeen = entries[0].isIntersecting;
        if (sSeen && !was) { paintStory(0); storyNext(); }
        if (!sSeen) { clearTimeout(sLoop); clearInterval(sSubTimer); }
      }, { threshold: 0.5 }).observe(sPin);
    } else {
      sSeen = true;
    }
    setHead();
    paintStory(0);
    storyNext();
    storyPar();
  }

  /* ── Тон сторінки й стрічка прогресу ──
     Тон бере секція, що перетинає середню лінію екрана. */
  var toned = qa('[data-gl-tone]');
  if (toned.length && 'IntersectionObserver' in window && !lite) {
    var toneIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) root.style.setProperty('--gl-tone', e.target.dataset.glTone);
      });
    }, { rootMargin: '-50% 0px -50% 0px' });
    toned.forEach(function (el) { toneIo.observe(el); });
    /* Пристрій здався на ходу: перестаємо перефарбовувати сторінку й
       лишаємо той один колір, який задає легкий режим у стилях. */
    liteOff.push(function () {
      toneIo.disconnect();
      root.style.removeProperty('--gl-tone');
    });
  }
  var progress = q('[data-gl-progress]');
  if (progress) {
    /* Довжину документа міряємо не щокадру: scrollHeight змушує браузер
       перерахувати розкладку, а вона змінюється хіба при зміні ширини
       чи коли сцена згортає свою доріжку (glDocChanged). */
    var progMax = 0;
    var progMeasure = function () { progMax = document.documentElement.scrollHeight - window.innerHeight; };
    var paintProgress = function (y) {
      if (lite) return;
      progress.style.transform = 'scaleX(' + (progMax > 0 ? Math.min((y || 0) / progMax, 1) : 0) + ')';
    };
    progMeasure();
    paintProgress(window.scrollY || window.pageYOffset || 0);
    onScroll(paintProgress);
    onResize(function () { progMeasure(); paintProgress(window.scrollY || window.pageYOffset || 0); });
    docFns.push(progMeasure);
    liteOff.push(function () { progress.style.transform = ''; });
  }

  /* ── Опитування про стиль ──
     Відповідь веде до пари з такою назвою в каруселі: прокручує до неї й обводить. */
  var models = qa('.gl-model');
  var strip = q('.gl-models');

  /* ── Стрічка прикладів і колесо миші ──
     Тут стояв обробник wheel: над стрічкою вертикальне колесо вело її
     вбік, щоб мишею теж можна було гортати. Він віддавав прокрутку
     сторінці на краях — і цього здавалося досить.

     Насправді сторінка застрягала намертво. Заміряно 13.10.2026: курсор
     над стрічкою, десять обертів колеса по 100 px — сторінка не зрушила
     жодного разу, і стрічка теж. Причини дві й вони множать одна одну:
     обробник забирав прокрутку через preventDefault, а scroll-snap-type
     x mandatory негайно доводив стрічку назад до початку, бо оберт
     колеса (100 px) менший за половину картки (300 px). Умова виходу
     дивилася на бажану позицію, якої стрічка ніколи не досягала, тож
     прокрутка не поверталася сторінці ніколи.

     Мишею стрічку й так можна гортати: на десктопі в неї є смуга
     прокрутки (вона підсвічується на hover), працює Shift+колесо, а
     відповідь у «What's her style?» сама прокручує до потрібної пари.
     Тому колесо більше не перехоплюємо — хай крутить сторінку, як
     усюди. */
  var quizA = q('[data-gl-quiz-a]');
  var quizTpl = D.quizAnswer;
  qa('[data-gl-quiz-model]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      qa('[data-gl-quiz-model]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      var want = btn.dataset.glQuizModel.trim().toLowerCase();
      var m = models.filter(function (x) {
        var n = q('.gl-model-name', x);
        return n && n.textContent.trim().toLowerCase() === want;
      })[0];
      models.forEach(function (x) { x.classList.toggle('is-picked', x === m); });
      if (m && strip) {
        strip.scrollTo({ left: m.offsetLeft - strip.offsetLeft - (strip.clientWidth - m.offsetWidth) / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      if (quizA) quizA.textContent = (quizTpl || '').replace('{model}', m ? q('.gl-model-name', m).textContent.trim() : btn.textContent.trim());
      burstAt(btn, 8, 50);
      track('style_picked', { style: btn.textContent.trim() });
    });
  });

  /* ── Липка кнопка ──
     Показується, поки на екрані не видно жодної з трьох кнопок «Create her
     gift», і ховається, поки покупець друкує — інакше вона перекриває поле
     над клавіатурою. v10: не заважає сценам — ховається, поки посередині
     екрана сцена-блокнот чи сцена з телефоном, і коли видно футер. */
  var sticky = q('[data-gl-sticky]');
  if (sticky) {
    var ctas = qa('[data-gl-cta]');
    var calmZones = [q('[data-gl-plan]'), q('[data-gl-story]')].filter(Boolean);
    var stickyFoot = q('.gl-footer');
    var typing = false;
    var seen = {};
    ctas.forEach(function (el) { seen[el.dataset.glCta] = false; });

    function paintSticky() {
      var h = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
      var anyVisible = ctas.some(function (el) {
        var r = el.getBoundingClientRect();
        return r.bottom > 10 && r.top < h - 10;
      });
      var inScene = calmZones.some(function (el) {
        var r = el.getBoundingClientRect();
        return r.top < h * 0.6 && r.bottom > h * 0.4;
      });
      var atFoot = stickyFoot ? stickyFoot.getBoundingClientRect().top < h - 10 : false;
      sticky.classList.toggle('is-on', !anyVisible && !typing && !inScene && !atFoot);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(paintSticky, { threshold: 0.01 });
      ctas.forEach(function (el) { io.observe(el); });
    }
    /* Раніше це рахувалось на кожну подію прокрутки — до сотні разів за
       секунду, і щоразу з вимірюванням п'яти елементів. Тепер раз на кадр,
       у спільному циклі. */
    onScroll(paintSticky);
    onResize(paintSticky);
    qa('[data-gl-input]').forEach(function (input) {
      input.addEventListener('focus', function () { typing = true; paintSticky(); });
      input.addEventListener('blur', function () { typing = false; paintSticky(); });
    });
    paintSticky();
  }

  /* ── Поява під час прокручування ──
     Одиночні елементи проявляються, коли доходять до екрана; у групах діти
     виходять по черзі; заголовки — по словах; цифри смуги довіри рахують від
     нуля. Клас gl-anim ставить ранній скрипт на початку розмітки. */
  if (root.classList.contains('gl-anim')) {
    var STEP = 90;
    var SINGLE = '.gl-eyebrow, .gl-lead, .gl-env, .gl-form-block, .gl-sum, .gl-fine, .gl-slot, .gl-zx-stage, ' +
      '.gl-proof-quote, .gl-who, .gl-marq, .gl-faq-mail, .gl-final-box > .gl-cta, .gl-hand-media, .gl-opens';
    var GROUPS = '.gl-hero-body, .gl-trust-in, .gl-models, .gl-quiz-opts, .gl-zx-tabs, .gl-faq-items';

    var splitWords = function (el, base) {
      var n = 0;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (c) {
          if (c.nodeType === 1) return walk(c);
          if (c.nodeType !== 3 || !c.nodeValue.trim()) return;
          var frag = document.createDocumentFragment();
          c.nodeValue.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) return frag.appendChild(document.createTextNode(part));
            var w = document.createElement('span');
            w.className = 'gl-w';
            w.textContent = part;
            w.style.setProperty('--gl-d', (base + Math.min(n++, 14) * 45) + 'ms');
            frag.appendChild(w);
          });
          node.replaceChild(frag, c);
        });
      })(el);
      el.setAttribute('data-gl-words', '');
    };

    var countUp = function (el) {
      var node = el.firstChild;
      var m = node && node.nodeType === 3 && node.nodeValue.match(/^(\s*)(\d[\d,]*(?:\.\d+)?)/);
      if (!m) return;
      var raw = m[2], target = parseFloat(raw.replace(/,/g, '')), dec = (raw.split('.')[1] || '').length;
      var rest = node.nodeValue.slice(m[0].length), t0 = null;
      var fmt = function (v) {
        var s = v.toFixed(dec);
        if (raw.indexOf(',') > -1) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return m[1] + s + rest;
      };
      (function tick(t) {
        if (t0 === null) t0 = t;
        var p = Math.min((t - t0) / 1400, 1);
        node.nodeValue = fmt(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(tick);
      })(performance.now());
    };

    var delayOf = function (el) { return parseInt(el.style.getPropertyValue('--gl-d'), 10) || 0; };

    /* is-in лишається назавжди (на ньому тримаються слова заголовків);
       прихований стан знімається разом із data-gl-in після переходу */
    var show = function (el) {
      el.classList.add('is-in');
      qa('[data-gl-words]', el).forEach(function (h) { h.classList.add('is-in'); });
      if (!el.hasAttribute('data-gl-in')) return;
      var d = delayOf(el);
      if (el.parentNode.classList.contains('gl-trust-in')) setTimeout(function () { countUp(el); }, d);
      if (el.hasAttribute('data-gl-env')) {
        setTimeout(function () { el.classList.add('is-open'); }, d + 350);
        setTimeout(function () { el.classList.add('is-done'); }, d + 2300);
      }
      setTimeout(function () {
        el.removeAttribute('data-gl-in');
        el.style.removeProperty('--gl-d');
      }, d + 1000);
    };

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        (e.target._glKids || [e.target]).forEach(show);
      });
    }, { rootMargin: '0px 0px -10% 0px' });

    /* Групи першими: їхні діти не повинні спрацювати ще й як одиночні */
    qa(GROUPS).forEach(function (g) {
      var kids = Array.prototype.slice.call(g.children);
      kids.forEach(function (k, i) {
        k.setAttribute('data-gl-in', '');
        k.style.setProperty('--gl-d', Math.min(i, 8) * STEP + 'ms');
      });
      g._glKids = kids;
      io.observe(g);
    });
    qa(SINGLE).forEach(function (el) {
      if (el.hasAttribute('data-gl-in') || el.closest('[data-gl-in]')) return;
      el.setAttribute('data-gl-in', '');
      io.observe(el);
    });
    /* Заголовок-учасник групи (h1 у hero) проявляється лише словами, без
       розмиття цілого блоку; заголовок усередині іншого блоку — разом із ним.
       У легкому режимі заголовки не розбиваються: десятки span-ів з окремим
       розмиттям на кожне слово — найдорожче, що є в появі. */
    if (lite) qa('.gl-h1, .gl-h2').forEach(function (h) { h.setAttribute('data-gl-words', ''); h.classList.add('is-in'); });
    else qa('.gl-h1, .gl-h2').forEach(function (h) {
      var base = delayOf(h);
      var inGroup = h.hasAttribute('data-gl-in');
      if (inGroup) { h.removeAttribute('data-gl-in'); h.style.removeProperty('--gl-d'); }
      var host = h.parentNode.closest('[data-gl-in]');
      splitWords(h, host ? delayOf(host) : base);
      if (!inGroup && !host) io.observe(h);
    });
    /* Групи першого екрана (hero, смуга довіри) — одразу, без прокрутки: смуга
       довіри стоїть по самому низу екрана, і спостерігач із «−10% знизу»
       не помічав її, доки не гортнеш пальцем */
    qa(GROUPS).forEach(function (g) {
      var r = g.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        io.unobserve(g);
        g._glKids.forEach(show);
      }
    });
    root.dataset.glAnimReady = '1';
  }

  /* ── Розсип перлин і страз ──
     Частинки вилітають з точки (x, y), трохи падають і за секунду зникають. */
  function burst(x, y, n, spread) {
    if (reduceMotion || !document.body.animate) return;
    for (var i = 0; i < n; i++) {
      var el = document.createElement('span');
      var pearl = Math.random() < 0.5;
      var size = pearl ? 6 + Math.random() * 8 : 8 + Math.random() * 10;
      el.className = 'gl-burst ' + (pearl ? 'gl-burst--pearl' : 'gl-burst--spark');
      el.style.setProperty('--s', size + 'px');
      document.body.appendChild(el);
      var a = Math.random() * Math.PI * 2;
      var d = spread * (0.45 + Math.random() * 0.55);
      var dx = Math.cos(a) * d, dy = Math.sin(a) * d * 0.8;
      var x0 = x - size / 2, y0 = y - size / 2;
      el.animate([
        { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(.3) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + (x0 + dx) + 'px,' + (y0 + dy) + 'px) scale(1) rotate(90deg)', opacity: 1, offset: 0.55 },
        { transform: 'translate(' + (x0 + dx * 1.15) + 'px,' + (y0 + dy + spread * 0.5) + 'px) scale(.7) rotate(160deg)', opacity: 0 }
      ], { duration: 900 + Math.random() * 400, easing: 'cubic-bezier(.2,.7,.3,1)' }).onfinish = el.remove.bind(el);
    }
  }
  function burstAt(el, n, spread) {
    var r = el.getBoundingClientRect();
    burst(r.left + r.width / 2, r.top + r.height / 2, n, spread);
  }

  function fillName(tpl) { return (tpl || '').replace('{name}', state.firstName.trim() || 'Bride'); }

  /* ── Тост унизу ── */
  var toastEl = q('[data-gl-toast]');
  var toastTxt = q('[data-gl-toast-txt]');
  var toastGo = q('[data-gl-toast-go]');
  var toastTimer = null;
  function toast(text, withGo, ms) {
    if (!toastEl) return;
    toastTxt.textContent = text;
    toastGo.hidden = !withGo;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    if (ms) toastTimer = setTimeout(function () { toastEl.hidden = true; }, ms);
  }
  if (toastEl) {
    q('[data-gl-toast-x]').addEventListener('click', function () { toastEl.hidden = true; });
    toastGo.addEventListener('click', function () { toastEl.hidden = true; track('draft_resumed'); });
  }

  /* ── Незакінчена справа ──
     Коли покупець сам ввів ім'я, чернетка (ім'я, прізвище, підпис, текст,
     привід) лишається в цьому браузері на 30 днів. Повернувся — поля вже
     заповнені, внизу «Emma's card is almost ready · Continue». Поки вкладку
     не видно, її заголовок нагадує про подарунок. */
  var DRAFT_KEY = 'glGiftDraft';
  var DRAFT_FIELDS = ['firstName', 'surname', 'yourName', 'message'];
  function saveDraft() {
    if (!state.nameTouched || !state.firstName.trim()) return;
    var d = { t: Date.now(), occasion: state.occasion, occasionOwn: state.occasionOwn };
    DRAFT_FIELDS.forEach(function (k) { d[k] = state[k]; });
    try { localStorage.setItem(DRAFT_KEY, JSON.stringify(d)); } catch (e) { /* приватне вікно */ }
  }
  var draft = null;
  try { draft = JSON.parse(localStorage.getItem(DRAFT_KEY) || 'null'); } catch (e) { /* немає доступу */ }
  if (draft && draft.firstName && Date.now() - (draft.t || 0) < 30 * 864e5) {
    DRAFT_FIELDS.forEach(function (k) {
      if (typeof draft[k] !== 'string') return;
      state[k] = draft[k];
      qa('[data-gl-input="' + k + '"]').forEach(function (inp) { inp.value = draft[k]; });
    });
    state.nameTouched = true;
    state.nameTracked = true;
    /* Своя нагода повертається в поле «Other», готова — натисканням чипа */
    if (draft.occasionOwn && occOther && occOwnInput) {
      occOwnInput.value = draft.occasionOwn;
      occOther.click();
    } else {
      var occBtn = qa('[data-gl-occ]').filter(function (b) { return b.dataset.glOcc === draft.occasion; })[0];
      if (occBtn) occBtn.click();
    }
    paintCtas();
    setTimeout(function () { toast(fillName(D.resumeText), true); }, 1600);
    /* дійшов до форми сам — нагадування більше не потрібне */
    var createSec = q('#create');
    if (createSec && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        if (es[0].isIntersecting && toastEl && !toastGo.hidden) toastEl.hidden = true;
      }).observe(createSec);
    }
    track('draft_restored');
  }

  var titleAway = D.titleAway;
  var titleBase = document.title;
  document.addEventListener('visibilitychange', function () {
    if (!titleAway || !state.nameTouched || !state.firstName.trim()) return;
    document.title = document.hidden ? fillName(titleAway) : titleBase;
  });

  /* ── Відео моменту: грає, лише поки на екрані ── */
  var vid = q('[data-gl-video]');
  if (vid) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      vid.controls = true;
      vid.preload = 'metadata';
    } else {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            var pr = vid.play();
            if (pr && pr.catch) pr.catch(function () { /* автоплей заборонено — лишається обкладинка */ });
          } else {
            vid.pause();
          }
        });
      }, { threshold: 0.3 }).observe(vid);
    }
  }

  /* ── Події ── */
  qa('[data-gl-track]').forEach(function (el) {
    el.addEventListener('click', function () {
      track('hero_cta_click', { placement: el.dataset.glTrack });
    });
  });
  /* ── Вікно «останній погляд» ──
     Стоїть між кнопкою й оплатою. Картку всередину копіюємо щоразу при
     відкритті: так вона точно збігається з тим, що покупець щойно склав,
     і нам не треба повторювати всю логіку її малювання.
     Нових полів тут немає — лише показ, тому вікно нічого не зберігає. */
  var rev = q('[data-gl-review]');
  var revBox = rev && q('.gl-rev-box', rev);
  var revCard = rev && q('[data-gl-review-card]', rev);
  var revGo = rev && q('[data-gl-review-go]', rev);
  var revAddon = rev && q('[data-gl-review-addon]', rev);
  var revEnv = rev && q('[data-gl-review-env]', rev);
  var revTag = rev && q('[data-gl-review-tag]', rev);
  var revFmtT = rev && q('[data-gl-review-fmt-title]', rev);
  var revFmtD = rev && q('[data-gl-review-fmt-desc]', rev);
  var revAddr = rev && q('[data-gl-review-addr]', rev);
  var revStep1T = rev && q('[data-gl-review-step1-t]', rev);
  var revStep1D = rev && q('[data-gl-review-step1-d]', rev);
  var revGoLabel = rev && q('[data-gl-review-go-label]', rev);
  var revBackTo = null;
  /* Дата друкованої картки — та сама, що й у списку форматів: її рахує
     блок data-gl-eta нижче по сторінці. Беремо вже готовий текст, щоб
     два місця не розходилися. */
  var revEta = function () {
    var t = q('[data-gl-eta]');
    return (t && t.textContent) || '';
  };

  var revFill = function () {
    var card = q('[data-gl-card]');
    if (card && revCard) {
      revCard.innerHTML = '';
      var copy = card.cloneNode(true);
      copy.removeAttribute('data-gl-card');
      /* у копії не потрібні ні підказки, ні власні обробники */
      qa('[data-gl-tip]', copy).forEach(function (t) { t.remove(); });
      /* Квадратик QR на картці — декоративна шахівниця. На сторінці це
         читається як частина візерунка, але у вікні, де покупець робить
         останню перевірку, він виглядав би як справжній код. Тому в копії
         лишаємо порожнє місце, а підпис під карткою пояснює, що QR
         з'явиться на готовій картці. */
      var qrBox = q('[data-gl-qr]', copy);
      if (qrBox) {
        qrBox.style.backgroundImage = 'none';
        qrBox.style.backgroundColor = 'transparent';
        qrBox.className += ' gl-rev-qrbox';
      }
      revCard.appendChild(copy);
    }
    /* Усе, що залежить від обраного формату. Конверт за карткою, ярлик
       над нею, опис способу вручення, рядок про адресу й перший крок —
       для друкованої картки вони інші. */
    var printed = state.delivery === 'printed';
    var eta = revEta();
    /* конверт виступає з-під картки вниз, тож підпису треба більше місця */
    if (rev) rev.classList.toggle('gl-rev--printed', printed);
    if (revAddon) revAddon.hidden = !printed;
    if (revEnv) revEnv.hidden = !printed;
    if (revAddr) revAddr.hidden = !printed;
    if (revTag) {
      var tag = printed ? D.revTagPrinted : D.revTagInstant;
      revTag.lastChild.nodeValue = eta ? String(tag).replace('%date%', eta) : String(tag).replace(' %date%', '').replace('%date%', '');
    }
    if (revFmtT) revFmtT.textContent = printed ? D.revFmtPrintedT : D.revFmtInstantT;
    if (revFmtD) {
      var desc = printed ? D.revFmtPrintedD : D.revFmtInstantD;
      revFmtD.textContent = eta ? String(desc).replace('%date%', eta) : String(desc).replace(' %date%', '').replace('%date%', '');
    }
    if (revStep1T) revStep1T.textContent = printed ? D.revStep1Tprinted : D.revStep1Tinstant;
    if (revStep1D) {
      var sd = printed ? D.revStep1Dprinted : D.revStep1Dinstant;
      revStep1D.textContent = eta ? String(sd).replace('%date%', eta) : String(sd).replace(' %date%', '').replace('%date%', '');
    }
    /* На вузькому екрані довгий підпис кнопки переносився і обрізався */
    if (revGoLabel) revGoLabel.textContent = window.innerWidth < 860 ? (D.revGoShort || D.revGoLabel) : D.revGoLabel;
  };

  var revOpen = function () {
    if (!rev) return;
    revFill();
    revBackTo = document.activeElement;
    rev.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (revBox) revBox.scrollTop = 0;
    if (revGo) revGo.focus();
    track('review_window_opened', { delivery: state.delivery, total: (q('[data-gl-total]') || {}).textContent || '' });
  };

  var revClose = function () {
    if (!rev || rev.hidden) return;
    rev.hidden = true;
    document.documentElement.style.overflow = '';
    if (revBackTo && revBackTo.focus) revBackTo.focus();
  };

  if (rev) {
    qa('[data-gl-review-close]', rev).forEach(function (el) { el.addEventListener('click', revClose); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') revClose(); });
    /* Та сама подія, що раніше йшла з кнопки сторінки: лічильники не
       втрачають момент, коли покупець справді пішов платити. */
    if (revGo) {
      revGo.addEventListener('click', function (e) {
        var style = q('[data-gl-style][aria-pressed="true"]');
        track('checkout_started', {
          occasion: state.occasion,
          card_style: style ? style.dataset.glStyle : '',
          delivery: state.delivery,
          total: (q('[data-gl-total]') || {}).textContent || ''
        });

        /* ── Додавання в кошик ──
           Варіант товару залежить від обраного формату картки: звичайний
           сертифікат або він же разом із друкованою карткою. Поки ID
           варіантів не заповнені в налаштуваннях секції, кнопка працює
           як було — веде за посиланням checkout_url або нікуди.
           Властивості пишемо в тому ж дусі, що й конструктор кросівок:
           те, що має бути видно в замовленні й у кошику, — звичайними
           іменами, службове — з підкресленням на початку. */
        var variant = state.delivery === 'printed' ? D.variantPrinted : D.variantInstant;
        if (!variant) {
          var href = revGo.getAttribute('href');
          if (!href || href === '#') e.preventDefault();
          return;
        }
        e.preventDefault();
        if (revGo.dataset.busy === '1') return;
        revGo.dataset.busy = '1';

        var props = {
          'For': state.firstName.trim() + (state.surname.trim() ? ' ' + state.surname.trim() : ''),
          'Message': state.message.trim(),
          'Signed': state.yourName.trim(),
          'Occasion': state.occasion,
          'Card': state.delivery === 'printed' ? 'Printed card + envelope' : 'Printable certificate',
          '_gl_style': style ? style.dataset.glStyle : '',
          '_gl_src': location.pathname
        };
        /* порожні поля в замовленні ні до чого */
        Object.keys(props).forEach(function (k) { if (!props[k]) delete props[k]; });

        /* ── Додати сертифікат і прибрати з кошика все інше ──
           З цієї сторінки покупець оплачує тільки сертифікат, тож решта
           кошика до оплати не йде.

           Порядок навмисний: спершу додаємо, потім прибираємо решту.
           Якби спершу чистили, збій на додаванні лишив би покупця і без
           кросівок, і без сертифіката.

           Прибираємо одним запитом update.js: він приймає кількості
           масивом у порядку ліній кошика, тож десять позицій коштують
           стільки ж, скільки одна. Свою лінію шукаємо за key, що його
           вернув add.js, а не за ідентифікатором варіанта: той самий
           сертифікат може вже лежати в кошику з іншим написом, і за
           варіантом ми затерли б і свій.

           Якщо свою лінію знайти не вдалося, кошик не чіпаємо зовсім —
           хай краще на оплату піде лишнє, ніж зникне потрібне. */
        var goPay = function () { location.href = D.afterAdd || D.cartUrl || '/cart'; };
        var ourKey = '';

        fetch((D.addUrl || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1, properties: props }] })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) {
              revGo.dataset.busy = '';
              toast((res.d && res.d.description) || 'Could not add to cart. Please try again.', false, 3200);
              return null;
            }
            var d = res.d || {};
            ourKey = d.key || (d.items && d.items[0] && d.items[0].key) || '';
            if (!ourKey) { goPay(); return null; }
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            if (!cart || !cart.items) return null;
            var others = 0;
            var updates = cart.items.map(function (it) {
              if (it.key === ourKey) return it.quantity;
              others += 1;
              return 0;
            });
            /* нашої лінії в кошику немає — не чистимо навмання */
            if (updates.every(function (n, i) { return cart.items[i].key !== ourKey; })) { goPay(); return null; }
            if (!others) { goPay(); return null; }
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            }).then(goPay, goPay);
          })
          .catch(function () {
            revGo.dataset.busy = '';
            toast('Network error. Please try again.', false, 3200);
          });
      });
    }
  }

  var checkout = q('[data-gl-checkout]');
  if (checkout) {
    checkout.addEventListener('click', function (e) {
      /* Нове: кнопка більше не веде просто на оплату, а показує підсумок */
      if (rev) {
        e.preventDefault();
        toast(fillName(D.celebrateText), false, 2600);
        revOpen();
        return;
      }
      toast(fillName(D.celebrateText), false, 2600);
      var href = checkout.getAttribute('href');
      if (href && href !== '#' && !reduceMotion && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        setTimeout(function () { location.href = href; }, 700);
      }
      track('checkout_started', {
        occasion: state.occasion,
        card_style: (q('[data-gl-style][aria-pressed="true"]') || {}).dataset ? q('[data-gl-style][aria-pressed="true"]').dataset.glStyle : '',
        delivery: state.delivery,
        total: (q('[data-gl-total]') || {}).textContent || ''
      });
    });
  }


  /* ── Перший екран: скільки займають оголошення, шапка й смуга довіри ──
     Hero бере висоту екрана мінус цю суму (--gl-above у стилях), щоб смуга
     довіри стояла саме внизу першого екрана. Окремо віддаємо висоту шапки
     (--gl-head): на ній зупиняється перший екран, коли лишається на місці. */
  var foldParts = [q('.gl-ann'), q('.gl-header'), q('.gl-trust')];
  /* Спершу всі виміри, потім усі записи. Раніше другий offsetHeight
     стояв після setProperty — браузер мусив перераховувати верстку
     наново посеред функції (20 мс у звіті PageSpeed). */
  var foldSet = function () {
    var h = 0;
    var head = 0;
    for (var i = 0; i < foldParts.length; i++) {
      if (!foldParts[i]) continue;
      var oh = foldParts[i].offsetHeight;
      h += oh;
      if (i === 1) head = oh;
    }
    root.style.setProperty('--gl-above', h + 'px');
    root.style.setProperty('--gl-head', head + 'px');
  };
  foldSet();
  onResize(foldSet);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(foldSet);

  /* ── Смуга довіри на телефоні: повільно їде по колу, пальцем тягнеться ──
     Пункти повторюються, доки стрічка не стане довшою за екран на цілий
     набір; зсув береться за модулем ширини набору, тож стику не видно.
     Копії — без data-gl-in: вони одразу видимі й з кінцевими цифрами.
     Відпустили — швидкість пальця плавно переходить у звичайний хід.
     Поза екраном стрічка стоїть. */
  var trust = q('.gl-trust');
  var trustIn = q('.gl-trust-in');
  if (trust && trustIn && matchMedia('(max-width:719.98px)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var tItems = Array.prototype.slice.call(trustIn.children);
    var tSetW = 0;
    var tAddSet = function () {
      tItems.forEach(function (s) {
        var c = s.cloneNode(true);
        c.removeAttribute('data-gl-in');
        c.style.removeProperty('--gl-d');
        c.setAttribute('aria-hidden', 'true');
        trustIn.appendChild(c);
      });
    };
    /* Усі виміри одразу, до змін DOM. Раніше умова циклу читала ширину
       після кожного tAddSet(), і браузер перераховував верстку наново на
       кожній ітерації — 26 мс у звіті PageSpeed, найдорожче місце нашого
       скрипта. Скільки наборів бракує, рахуємо арифметикою: ширина
       набору від додавання копій не змінюється. */
    var tMeasure = function () {
      var second = trustIn.children[tItems.length];
      if (!second) return;
      tSetW = second.offsetLeft - tItems[0].offsetLeft;
      var have = trustIn.offsetWidth;
      var need = tSetW + trust.clientWidth + 40;
      if (tSetW <= 0 || have >= need) return;
      var sets = Math.ceil((need - have) / tSetW);
      if (sets > 6) sets = 6;
      for (var i = 0; i < sets; i++) tAddSet();
    };
    tAddSet();
    tMeasure();
    trust.classList.add('is-loop');
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(tMeasure);
    onResize(tMeasure);

    var tAuto = -22; /* px за секунду, вліво */
    var tOff = 0, tVel = tAuto, tDrag = null, tLast = 0, tRaf = 0, tSeen = true;
    var tFrame = function (t) {
      if ((!tSeen && !tDrag) || lite) { tRaf = 0; tLast = 0; return; }
      var dt = tLast ? Math.min((t - tLast) / 1000, 0.05) : 0;
      tLast = t;
      if (!tDrag) {
        tVel += (tAuto - tVel) * Math.min(dt * 1.8, 1);
        tOff += tVel * dt;
      }
      if (tSetW > 0) { tOff %= tSetW; if (tOff > 0) tOff -= tSetW; }
      trustIn.style.transform = 'translate3d(' + tOff.toFixed(2) + 'px,0,0)';
      tRaf = requestAnimationFrame(tFrame);
    };
    var tStart = function () { if (!tRaf) tRaf = requestAnimationFrame(tFrame); };
    tStart();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        tSeen = entries[0].isIntersecting;
        if (tSeen) tStart();
      }).observe(trust);
    }

    trustIn.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') e.preventDefault();
      tDrag = { x: e.clientX, off: tOff, lx: e.clientX, t: e.timeStamp, v: 0 };
      tVel = 0;
      try { trustIn.setPointerCapture(e.pointerId); } catch (err) {}
      tStart();
    });
    trustIn.addEventListener('pointermove', function (e) {
      if (!tDrag) return;
      var dt = (e.timeStamp - tDrag.t) / 1000;
      if (dt > 0) tDrag.v = tDrag.v * 0.4 + ((e.clientX - tDrag.lx) / dt) * 0.6;
      tDrag.t = e.timeStamp;
      tDrag.lx = e.clientX;
      tOff = tDrag.off + (e.clientX - tDrag.x);
    });
    var tRelease = function (e) {
      if (!tDrag) return;
      /* Палець затримали перед відпусканням — поштовху немає */
      var v = e.timeStamp - tDrag.t > 90 ? 0 : tDrag.v;
      tVel = Math.max(-1600, Math.min(1600, v));
      tDrag = null;
    };
    trustIn.addEventListener('pointerup', tRelease);
    trustIn.addEventListener('pointercancel', tRelease);
  }

  /* ── Сцена-блокнот: кроки перебирає прокрутка ──
     З макета source/gl-v4. v11: сцена спиняється на екрані, і кожен крок
     прокрутки вписує одне рішення: дата → місце → гості → її сторінка.
     Порожній розворот свого кроку не займає: перший пункт пишеться,
     щойно сцена стала на місце. Назад
     прокрутили — кроки йдуть у зворотному порядку. Тап по блокноту дописує кадр, що ще пишеться.
     --e — наскільки секція
     зайшла на екран (блокнот «сідає» на місце). --hdr — липка шапка
     (лише від 720px): сцена займає екран під нею. Якщо під шапкою менше
     470px або «зменшений рух» — розворот одразу готовий. */
  var plan = q('[data-gl-plan]');
  if (plan) {
    var plPin = q('.gl-pl__pin', plan);
    var plLayers = qa('[data-gl-pi]', plan);
    var plHead = q('.gl-header');
    var plCalm = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var plHdr = 0, plCta = 0, plStep = -1, plLive = false, plDone = false, plSpent = false;
    /* Кадри по порядку: дата, місце, гості, її сторінка — перший пункт уже вписаний, порожнього блокнота немає */
    /* Кроки прокрутки: перші три рядки блокнота пишуться разом, четвертий —
       окремо. Так сцена не змушує гортати вхолосту заради кожного рядка. */
    var PL_GROUPS = [[0, 1, 2], [3]];
    var PL_LAST = PL_GROUPS.length - 1;
    var plGroupOf = function (n) { for (var i = 0; i < PL_GROUPS.length; i++) if (PL_GROUPS[i].indexOf(n) >= 0) return i; return PL_LAST; };
    /* Яку частку доріжки займає хвіст, на якому сцена тане (з --pl-span і --pl-out) */
    var PL_OUT = 72 / (2 * 58 + 72);
    /* Скільки триває запис кожного кадру (за затримками в стилях), з тим
       самим темпом --pl-k, що й у CSS, — щоб тап «дописати кадр» знав правду */
    var PL_ANIM = { '0': 2000, '1': 3500 };
    var plK = parseFloat(getComputedStyle(plan).getPropertyValue('--pl-k')) || 1;
    var plAt = 0;
    /* Пишемо лише зміни */
    var plAttr = function (el, name, val) {
      if (val === null) { if (el.hasAttribute(name)) el.removeAttribute(name); }
      else if (el.getAttribute(name) !== val) el.setAttribute(name, val);
    };
    var plProp = function (el, name, val) { if (el.style.getPropertyValue(name) !== val) el.style.setProperty(name, val); };
    var plClamp = function (v) { return Math.max(0, Math.min(1, v)); };
    var plSet = function (step) {
      plStep = step;
      plAt = Date.now();
      plAttr(plan, 'data-gl-pstep', String(step));
      plLayers.forEach(function (el) {
        var g = plGroupOf(+el.getAttribute('data-gl-pi'));
        plAttr(el, 'data-gl-pos', g < step ? 'before' : g > step ? 'after' : 'on');
      });
      if (step === PL_LAST && !plDone) { plDone = true; track('planner_complete'); }
    };
    /* Висоти секції й кадру беремо тут, а не в кожному кадрі прокрутки:
       offsetHeight — це перерахунок розкладки, а на прокрутці вони не
       міняються. plTrack — доріжка, по якій пишуться кроки. */
    var plTrack = 0, plPinH = 0;
    var plSize = function () { plPinH = plPin.offsetHeight; plTrack = plan.offsetHeight - plPinH; };
    var plMeasure = function () {
      plHdr = plHead && getComputedStyle(plHead).position === 'sticky' ? plHead.offsetHeight : 0;
      var vh = window.innerHeight;
      var live = vh - plHdr - plCta >= 470 && !plSpent && !lite;
      plProp(plan, '--hdr', plHdr + 'px');
      plProp(plan, '--cta', plCta + 'px');
      plAttr(plan, 'data-gl-live', live ? '' : null);
      plSize();
      if (live !== plLive) {
        plLive = live;
        if (!live || plCalm) plSet(PL_LAST);
        else plScroll();
      }
    };
    /* Тап по блокноту: кадр, що ще пишеться, показати дописаним.
       Проміжний стан «x» з вимкненими переходами зупиняє ті, що вже йдуть. */
    var plBook = q('.gl-pl-book', plan);
    plBook.addEventListener('click', function () {
      if (!plLive || plCalm) return;
      if (plan.classList.contains('is-instant') || Date.now() - plAt >= (PL_ANIM[String(plStep)] || 0) * plK) return;
      var now = plStep;
      plan.classList.add('is-instant');
      plAttr(plan, 'data-gl-pstep', 'x');
      plLayers.forEach(function (el) { plAttr(el, 'data-gl-pos', 'x'); });
      void plan.offsetWidth;
      plSet(now);
      void plan.offsetWidth;
      track('planner_tap', { step: now });
    });
    /* Який кадр показувати: скільки доріжки під сценою вже пройдено.
       Доріжка — це висота секції мінус сам кадр, тобто чотири кроки. */
    var plScroll = function () {
      if (!plLive || plCalm) { plPin.style.opacity = ''; plPin.style.transform = ''; return; }
      var track = plTrack;
      if (track <= 0) return;
      var gone = plHdr + plCta - plan.getBoundingClientRect().top;
      var steps = track * (1 - PL_OUT);
      var p = plClamp(gone / steps);
      /* Поки сцена ще заходить на екран, блокнот порожній; щойно вона стала
         на місце — одразу пишеться перший пункт, свого кроку прокрутки
         порожній розворот більше не займає. */
      var step = gone < 0 ? -1 : Math.min(PL_LAST, Math.floor(p * PL_GROUPS.length));
      /* Пишеться один раз за візит: кадр лише зростає. Назад блокнот не
         стирається, і повторний прохід униз нічого не переписує — сцена
         просто їде повз уже дописаний розворот. */
      if (step > plStep) { plan.classList.remove('is-instant'); plSet(step); }
      /* Хвіст: сцена просто тане, не рушаючи з місця */
      var out = plClamp((gone - steps) / (track - steps));
      var e = out * out * (3 - 2 * out);
      plPin.style.opacity = out ? (1 - e).toFixed(3) : '';
      plPin.style.transform = '';
    };
    /* ── Доріжка згортається, коли сцена відіграла ──
       Довга секція потрібна лише один раз: поки блокнот пишеться. Розворот
       назад не стирається, тож на зворотному шляху ці три екрани — порожня
       затримка. Щойно сцена дописана й пішла за верх вікна, знімаємо
       data-gl-live: секція стає звичайним блоком заввишки з розворот.
       Документ коротшає, тож усе нижче під'їжджає вгору. Щоб екран не
       смикнувся, дивимось, на скільки зсунувся сусідній блок, і на стільки ж
       правимо прокрутку. Міряємо саме зсув, а не висоту документа: браузер
       може підрівняти прокрутку сам (scroll anchoring), і тоді правити нічого
       не треба — різниця вийде нульова. */
    var plSpend = function () {
      if (plSpent || !plLive || plCalm) return;
      var mark = plan.nextElementSibling;
      var was = mark ? mark.getBoundingClientRect().top : 0;
      plSpent = true;
      plMeasure();
      plPin.style.opacity = '';
      plPin.style.transform = '';
      if (mark) {
        var d = mark.getBoundingClientRect().top - was;
        if (d) jumpTo((window.scrollY || window.pageYOffset || 0) + d);
      }
      docChanged();
    };
    var plEnter = function () {
      var r = plan.getBoundingClientRect();
      var vh = window.innerHeight;
      plProp(plan, '--e', (plCalm ? 1 : plClamp((vh - r.top) / Math.max(1, vh - plHdr))).toFixed(3));
      plScroll();
      /* ── Чому доріжку більше не згортаємо ──
         Тут стояло: сцена дописана й пішла за верх вікна — знімаємо
         data-gl-live, і три екрани доріжки зникають. Око цього не бачило:
         висота документа падала на 1001 px і рівно на стільки ж
         підправлялась прокрутка (перевірено вимірюванням). Але Chrome
         рахує стрибок верстки за зміщенням у вікні й програмну прокрутку
         при цьому не віднімає, тож кожен візит отримував CLS 1.0 при
         допустимих 0.1 — сторінка йшла в Search Console як «погана».
         Прощаються лише зсуви за 500 мс після тапу чи клавіші; прокрутка
         за дію людини не рахується, тож відкласти згортання нікуди.
         Ціна відмови — на зворотному шляху вгору близько двох екранів
         уже дописаного розвороту. plSpend лишається для слабких
         пристроїв (liteOff): там сцена стає звичайним блоком одразу. */
    };
    onScroll(plEnter);
    onResize(function () { plMeasure(); plEnter(); });
    docFns.push(plSize);
    /* Слабкий пристрій: сцена стоїть звичайним блоком із дописаним розворотом */
    liteOff.push(function () { plSet(PL_LAST); plSpend(); });
    plSet(-1);
    plMeasure();
    plEnter();
    if (plCalm || !plLive) plSet(PL_LAST);
  }



  /* ── v11 · Перехід першої сцени ──
     Поки прокручено менше за висоту першого екрана, він тане: прозорість
     від 1 до 0 і ледь помітне зменшення. Рахуємо на кадрі прокрутки, щоб
     не смикалось. Коли екран уже прозорий, нічого не перемальовуємо. */
  var folds = qa('[data-gl-fold]');
  /* Слабкий телефон переходів не отримує взагалі: стилі роблять екрани
     звичайними блоками, а рахувати їхнє згасання на кожній прокрутці —
     марна робота саме там, де кадрів і так бракує. */
  if (folds.length && !reduceMotion && !lite) {
    /* Де екран стоїть у документі — міряємо без власного зсуву, інакше
       розрахунок годувався б своїм же результатом */
    var foldTop = function (el) {
      var was = el.style.transform;
      el.style.transform = '';
      var t = el.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
      el.style.transform = was;
      return t;
    };
    var foldItems = [];
    /* data-gl-fold-fade — на якій частці своєї висоти екран устигає розтанути
       (менше — швидше; за замовчуванням 0.72).
       data-gl-fold-hold — скільки екран стоїть цілим, перш ніж почне танути
       (частка його висоти). Наступному шару на цей час додаємо відступ, тож він
       наїжджає не одразу, а коли затримка вийшла. */
    /* Висоту шару, його місце в документі й висоту шапки беремо тут: на
       прокрутці вони не міняються, а offsetHeight і getComputedStyle щокадру
       коштували браузеру повного перерахунку розкладки. */
    var foldHead = 0;
    var foldMeasure = function () {
      foldHead = parseFloat(getComputedStyle(root).getPropertyValue('--gl-head')) || 0;
      foldItems = folds.map(function (el) {
        /* Екран, який на цій ширині чи висоті не закріплюється, лишаємо в
           спокої: ні затримки наступному шару, ні згасання — інакше в потоці
           з'явився б порожній розрив. */
        var sticky = getComputedStyle(el).position === 'sticky';
        var h = el.offsetHeight || 1;
        var hold = sticky ? h * (parseFloat(el.getAttribute('data-gl-fold-hold')) || 0) : 0;
        var fade = parseFloat(el.getAttribute('data-gl-fold-fade')) || 0.72;
        var next = el.nextElementSibling;
        if (next) next.style.marginTop = hold ? Math.round(hold) + 'px' : '';
        if (!sticky) { el.style.opacity = ''; el.style.transform = ''; }
        return { el: el, top: foldTop(el), h: h, hold: hold, fade: fade, was: -1, sticky: sticky };
      });
    };
    /* Ефект рахується з самої позиції прокрутки, тож іде однаково в обидва
       боки: повернувся вгору — екран так само проявився назад. Геометрія при
       цьому не міняється, тож ні порожнеч, ні стрибків. */
    /* ── Затримка «спалюється» після проходу ──
       Поки екран стоїть цілим, наступний шар чекає на відступі hold. Униз це
       пауза перед наїздом, назад — порожня зупинка ні для чого. Тож коли
       екран уже позаду, відступ знімаємо назавжди (разом з атрибутом, щоб
       перевимірювання його не повернуло) і на ту саму різницю зсуваємо
       прокрутку — видиме лишається на місці. Саме згасання й наїзд шарів
       нікуди не діваються, зникає тільки очікування. */
    var foldSpend = function (it) {
      if (!it.hold) return;
      var next = it.el.nextElementSibling;
      var was = next ? next.getBoundingClientRect().top : 0;
      it.el.removeAttribute('data-gl-fold-hold');
      foldMeasure();
      if (next) {
        var d = next.getBoundingClientRect().top - was;
        if (d) jumpTo((window.scrollY || window.pageYOffset || 0) + d);
      }
      docChanged();
    };
    var foldPaint = function (at) {
      var y = at === undefined ? (window.scrollY || window.pageYOffset || 0) : at;
      var spend = null;
      foldItems.forEach(function (it) {
        if (!it.sticky) return;
        var p = Math.min(Math.max((y + foldHead - it.top - it.hold) / (it.h * it.fade), 0), 1);
        /* Екран пройдено донизу з запасом — його затримка більше не потрібна */
        if (!spend && it.hold && y > it.top + it.h + it.hold + 200) spend = it;
        if (Math.abs(p - it.was) < 0.003) return;
        it.was = p;
        /* Тільки прозорість: екран, під який наїжджає наступний, стоїть на
           місці й розчиняється. Раніше він ще й повільно повз угору — рух
           читався як гальмування прокрутки. */
        var e = p * p * (3 - 2 * p);
        it.el.style.opacity = (1 - e).toFixed(3);
        it.el.style.transform = '';
      });
      /* Міряємо заново поза циклом: foldSpend перебирає foldItems */
      if (spend) { foldSpend(spend); foldPaint(); }
    };
    foldMeasure();
    foldPaint();
    onScroll(foldPaint);
    onResize(function () { foldMeasure(); foldPaint(); });
    docFns.push(function () { foldMeasure(); foldPaint(); });
    /* Слабкий пристрій: шари стоять у потоці, без закріплення й згасання */
    liteOff.push(function () {
      foldItems.forEach(function (it) {
        it.el.removeAttribute('data-gl-fold-hold');
        it.el.style.opacity = '';
        it.el.style.transform = '';
        if (it.el.nextElementSibling) it.el.nextElementSibling.style.marginTop = '';
      });
      foldItems = [];
      docChanged();
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { foldMeasure(); foldPaint(); });
  }

  /* ── v11 · «Як це працює»: кадри самі йдуть по колу ──
     Кожен кадр показується HW_HOLD, а в активній пігулці росте смуга
     прогресу. Притиснули пігулку — її кадр стає на місце й усе завмирає;
     відпустили — цикл іде далі з нього. Пальцем сцену можна гортати,
     стрілками — коли фокус на кроках. Поки сцени не видно, цикл спить.
     Тексти активного кроку лежать у data-атрибутах кнопок. */
  var hw = q('[data-gl-hw]');
  if (hw) {
    var hwSteps = qa('[data-gl-hw-go]', hw);
    var hwSlots = qa('[data-gl-hw-slot]', hw);
    var hwScene = q('[data-gl-hw-scene]', hw);
    var hwT = q('[data-gl-hw-t]', hw), hwW = q('[data-gl-hw-w]', hw), hwB = q('[data-gl-hw-b]', hw);
    var hwLink = q('[data-gl-hw-link]', hw);
    var HW_HOLD = 4000;
    /* Довжина кадру лежить у розмітці: у кожного своя, бо сценарії
       різні за довжиною. Немає атрибута — старі 4 с. */
    /* Швидкість сцени. ?slow=3 сповільнює втричі для розбору — разом із
       довжиною кадру сповільнюються і самі анімації: їм задається
       playbackRate, тож жодних чисел у стилях чіпати не треба. */
    var hwSlow = 1;
    (function () {
      var m = /[?&]slow=([\d.]+)/.exec(location.search);
      if (m) hwSlow = Math.max(0.2, Math.min(10, parseFloat(m[1]) || 1));
    })();
    /* Лабораторія (?lab=1, сторінка /pages/gl-lab): цикл кадрів стоїть,
       сцена світиться завжди, а керує нею пульт window.glLab. */
    var hwLab = /[?&]lab=1/.test(location.search);
    var hwLen = function (i) { var v = hwSlots[i] && +hwSlots[i].getAttribute('data-gl-hw-len'); return (v > 0 ? v : HW_HOLD) * hwSlow; };
    var hwRate = function () {
      if (hwSlow === 1 || !hw.getAnimations) return;
      requestAnimationFrame(function () {
        hw.getAnimations({ subtree: true }).forEach(function (a) {
          try { a.playbackRate = 1 / hwSlow; } catch (e) {}
        });
      });
    };
    var hwNow = 0, hwLeft = HW_HOLD, hwHeld = false, hwSeen = false, hwLast = 0;
    var hwFill = function (p) {
      var f = hwSteps[hwNow] && q('.gl-hw-step-fill', hwSteps[hwNow]);
      if (f) f.style.transform = 'scaleX(' + p.toFixed(3) + ')';
    };
    var hwSet = function (i, byUser) {
      var n = hwSteps.length;
      i = (i % n + n) % n;
      hwLeft = hwLen(i);
      hwSteps.forEach(function (b) { var f = q('.gl-hw-step-fill', b); if (f) f.style.transform = 'scaleX(0)'; });
      if (i === hwNow && hwSlots[i] && hwSlots[i].classList.contains('is-on')) return;
      var back = (i - hwNow + n) % n === n - 1;
      if (hwScene) hwScene.setAttribute('data-gl-hw-dir', back ? 'back' : 'fwd');
      var out = hwSlots[hwNow];
      hwNow = i;
      var st = hwSteps[i];
      hwSteps.forEach(function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      /* Кожен кадр прибирає за собою сам: спільний таймер при швидкому
         перемиканні скасовувався, і кадр, який вийшов раніше, лишався
         зсунутим убік назавжди — визирав з-за краю сцени. */
      hwSlots.forEach(function (sl, k) {
        sl.classList.toggle('is-on', k === i);
        if (k === i || (out && sl !== out)) {
          clearTimeout(sl.glOutT);
          sl.classList.remove('is-out', 'is-back');
        }
      });
      /* кадр, що пішов, ще мить їде вбік — потім знову чекає збоку */
      if (out && out !== hwSlots[i]) {
        out.classList.toggle('is-back', back);
        out.classList.add('is-out');
        clearTimeout(out.glOutT);
        out.glOutT = setTimeout(function () { out.classList.remove('is-out', 'is-back'); }, 1200);
      }
      if (hwT) hwT.textContent = st.dataset.t;
      if (hwW) hwW.textContent = st.dataset.w;
      if (hwB) hwB.textContent = st.dataset.b;
      if (hwLink) hwLink.hidden = st.dataset.link !== '1';
      hwRate();
      if (byUser) track('how_step_selected', { step: st.dataset.t });
    };
    /* Цикл: поки сцену видно й ніхто не тримає пігулку, час іде */
    var hwRaf = 0;
    var hwFrame = function (t) {
      hwRaf = 0;
      /* Цикл спить, поки сцени не видно: раніше кадр крутився весь час,
         навіть коли «Як це працює» лишилось далеко позаду */
      if (hwHeld || !hwSeen || reduceMotion || lite) { hwLast = 0; return; }
      var dt = hwLast ? Math.min(t - hwLast, 120) : 0;
      hwLast = t;
      hwLeft -= dt;
      hwFill(1 - Math.max(0, hwLeft) / hwLen(hwNow));
      if (hwLeft <= 0) hwSet(hwNow + 1);
      hwRaf = requestAnimationFrame(hwFrame);
    };
    var hwStart = function () { if (!hwRaf) hwRaf = requestAnimationFrame(hwFrame); };
    /* Притиснули пігулку — показати її кадр і завмерти, відпустили — далі */
    var hwRelease = function () { hwHeld = false; hwStart(); };
    hwSteps.forEach(function (b, i) {
      b.addEventListener('pointerdown', function () { hwHeld = true; hwSet(i, true); });
      b.addEventListener('click', function (e) { e.preventDefault(); hwSet(i, true); });
    });
    window.addEventListener('pointerup', hwRelease);
    window.addEventListener('pointercancel', hwRelease);
    window.addEventListener('blur', hwRelease);
    if (hwScene) {
      var hwX = 0, hwY = 0;
      hwScene.addEventListener('touchstart', function (e) { hwX = e.touches[0].clientX; hwY = e.touches[0].clientY; }, { passive: true });
      hwScene.addEventListener('touchend', function (e) {
        var c = e.changedTouches[0], dx = c.clientX - hwX, dy = c.clientY - hwY;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy)) hwSet(hwNow + (dx < 0 ? 1 : -1), true);
      }, { passive: true });
    }
    hw.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      hwSet(hwNow + (e.key === 'ArrowRight' ? 1 : -1), true);
      hwSteps[hwNow].focus();
    });
    if (hwLab) {
      hwHeld = true;
      if (hwScene) hwScene.classList.add('is-live');
      window.glLab = {
        frames: hwSlots.length,
        len: function (i) { return +hwSlots[i].getAttribute('data-gl-hw-len') || HW_HOLD; },
        frame: function () { return hwNow; },
        go: function (i) { hwSet(i); },
        anims: function () { return hw.getAnimations ? hw.getAnimations({ subtree: true }) : []; }
      };
      /* Кадр чекає на нулі, поки його не пустять із пульта */
      requestAnimationFrame(function () {
        window.glLab.anims().forEach(function (a) { try { a.currentTime = 0; a.pause(); } catch (e) {} });
      });
    } else if ('IntersectionObserver' in window) {
      /* is-live вмикає анімацію всередині кадру: поки сцени не видно,
         кадр стоїть, а коли вона повертається — грає з початку */
      new IntersectionObserver(function (es) {
        hwSeen = es[0].isIntersecting;
        if (hwScene) hwScene.classList.toggle('is-live', hwSeen);
        if (hwSeen) { hwStart(); hwRate(); }
      }, { threshold: 0.25 }).observe(hw);
    } else {
      hwSeen = true;
      if (hwScene) hwScene.classList.add('is-live');
    }
    hwSlots.forEach(function (sl, k) { sl.classList.toggle('is-on', k === 0); });
    /* Скільки місця треба під опис: приміряємо кожен крок разом із
       посиланням і лишаємо найбільшу висоту, щоб сцена не стрибала
       і написи не вилазили за екран */
    var hwNowBox = q('.gl-hw-now', hw);
    /* Одиниця композиції: висота сцени, а на вузькому екрані — частка її
       ширини. Рахуємо в скрипті, бо висоту сцени задає розкладка, і в
       самому CSS контейнер її не знає. Від неї залежать розміри конверта,
       рук, коробки й пари — інакше на іншому екрані вони розходяться. */
    var hwUnit = function () {
      if (!hwScene) return;
      var r = hwScene.getBoundingClientRect();
      if (!r.height || !r.width) return;
      /* На телефоні сцена майже квадратна: якщо міряти її так само, як
         широку, одиниця виходить утричі менша і все стає дрібним. */
      var narrow = r.width < 640;
      var u = narrow ? Math.min(r.height * 0.88, r.width * 0.88)
                     : Math.min(r.height, r.width * 0.34);
      hwScene.style.setProperty('--h', Math.round(u) + 'px');
    };
    hwUnit();
    var hwFit = function () {
      hwUnit();
      if (!hwNowBox || !hwT || !hwW || !hwB) return;
      var t = hwT.textContent, w = hwW.textContent, b = hwB.textContent;
      var linkWas = hwLink && hwLink.hidden;
      if (hwLink) hwLink.hidden = false;
      hwNowBox.style.minHeight = '';
      var max = 0;
      hwSteps.forEach(function (st) {
        hwT.textContent = st.dataset.t;
        hwW.textContent = st.dataset.w;
        hwB.textContent = st.dataset.b;
        max = Math.max(max, hwNowBox.offsetHeight);
      });
      hwT.textContent = t; hwW.textContent = w; hwB.textContent = b;
      if (hwLink) hwLink.hidden = linkWas;
      hwNowBox.style.minHeight = max + 'px';
    };
    hwSet(0);
    /* hwFit примірює по черзі текст кожного кроку й міряє висоту — на
       кожній примірці браузер перераховує верстку наново (19 мс у звіті
       PageSpeed). Переробляти примірку на клони ризиковано, зате сам
       виклик можна прибрати з критичного шляху: блок «How it works»
       лежить далеко нижче першого екрана, тож поміряти його можна тоді,
       коли браузер звільниться. Зсуву це не додає — за межами вікна
       браузер його не рахує, і до блоку покупець доходить значно
       пізніше. */
    if (window.requestIdleCallback) requestIdleCallback(hwFit, { timeout: 2500 });
    else setTimeout(hwFit, 400);
    var hwFitT = null;
    onResize(function () { clearTimeout(hwFitT); hwFitT = setTimeout(hwFit, 150); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(hwFit);
    if (!hwLab) hwStart();
    /* Слабкий пристрій: кадри стоять, перемикають їх пігулками */
    liteOff.push(function () { if (hwRaf) { cancelAnimationFrame(hwRaf); hwRaf = 0; } });
  }

  /* ── Зони: перебір оздоблення й полоса варіантів біля активної зони ──
     Шари, назви варіантів і шрифти — з конфігу конструктора Bride
     (kf-bride-config.json, вантажиться біля екрана). Перебір іде сам, поки
     кросівок на екрані: вкладка чи тап по кросівку лише перескакують на свою
     зону. Поруч з активною зоною стоїть полоса її оздоблень — на широкому
     екрані праворуч від кнопки, на телефоні під рядком кнопок. Тап по
     варіанту ставить його на кросівок і спиняє перебір: далі пара клацає
     сама. При «зменшеному русі» перебір не стартує — полоса працює руками. */
  var zx = q('[data-gl-zx]');
  if (zx) {
    var zxRow = q('.gl-zx-tabs', zx);
    var zxPick = q('.gl-zx-pick', zx);
    var zxDeco = q('[data-gl-zx-deco]', zx);
    var zxDecoK = q('[data-gl-zx-deco-k]', zx);
    var zxDecoRow = q('[data-gl-zx-deco-row]', zx);
    var zxNow = q('.gl-zx-now', zx);
    var zxEl = q('[data-gl-zx-el]', zx);
    var zxDecor = q('[data-gl-zx-decor]', zx);
    var zxNameBox = q('.gl-zx-name', zx);
    var zxBtns = qa('[data-gl-zx-go]', zx);
    /* Шари беремо полегшені (glz-*.webp): у конфігу стоять важкі PNG
       конструктора, лендінгу вистачає копії на 1400px. Шрифти — як є. */
    /* Розмір шарів під місце, а не під запас. Кросівок у вікні конструктора
       займає близько 434px на телефоні і 820px на широкому екрані — навіть
       з поправкою на щільність пікселів. Тому вузькому екрану даємо набір
       «-xs» (520px), решті «-sm» (900px); повні 1400px не потрібні ніде,
       вони лишаються тільки як запасний src у розмітці.
       Вузький екран бере ті самі -xs, що й сцени «How it works» вище, —
       отже вантажить їх один раз на обидва місця. */
    /* Завжди набір «-sm» (900px). Кросівок у вікні конструктора просить
       близько 800px на телефоні (94vw при подвійній щільності) і 820px на
       широкому екрані — тобто 900px вистачає скрізь, а повні 1400px не
       потрібні ніде. Раніше широкий екран тягнув саме їх.
       Менший набір «-xs» тут не годиться: 520px помітно нижче за потребу.
       Його беруть сцени «How it works», де кросівок удвічі дрібніший. */
    var zxLite = function (f) {
      /* шрифти (.ttf) проходять повз: заміна чіпає лише .webp */
      var n = /^kfb-.+\.png$/.test(f) ? 'glz-' + f.slice(4, -4) + '.webp' : f;
      return n.replace(/\.webp$/, '-sm.webp');
    };
    var zxUrl = function (file) { return zx.dataset.asset.replace('glz-base.webp', encodeURIComponent(zxLite(file))); };
    var zxCalm = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var zxCfg = null, zxSel = {}, zxFont = 0, zxOrder = [], zxTimer = null, zxSeen = false, zxLoading = false, zxSwap = null;
    /* zxHold — пара вибрала оздоблення руками, перебір більше не вмикаємо.
       zxKey — зона, чия полоса стоїть зараз (щоб не перемальовувати марно). */
    var zxHold = false, zxKey = null, zxNameOff = false;
    /* «Без напису» — такий самий порожній варіант, як «No Custom» у зон */
    var ZX_NONAME = { name: 'No Name', key: 'no-name' };
    var zxTabLabel = function (key) {
      var t = q('.gl-zx-tab[data-gl-zx-go="' + key + '"]', zx);
      return t ? t.lastChild.textContent.trim() : key;
    };
    var zxMark = function (key, decor) {
      zxBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.glZxGo === key));
      });
      zxNow.classList.add('is-swap');
      clearTimeout(zxSwap);
      zxSwap = setTimeout(function () {
        zxEl.textContent = zxTabLabel(key);
        zxDecor.textContent = decor;
        zxNow.classList.remove('is-swap');
      }, 180);
    };
    /* Варіанти зони: у звичайній зоні це оздоблення без «no-custom»,
       у вкладці з іменем — шрифти. «No Custom» лишається лише як стартовий
       стан шару, у полосі його немає. */
    /* Усі варіанти зони — разом із «No Custom»: у полосі він потрібен, щоб
       можна було зняти оздоблення й побачити зону чистою. */
    var zxOptsOf = function (key) {
      if (!zxCfg) return [];
      if (key === 'name') return [ZX_NONAME].concat(zxCfg.text.fonts);
      var z = zxCfg.zones.filter(function (x) { return x.key === key; })[0];
      return z ? z.options : [];
    };
    var zxOptName = function (key, o) { return (key === 'name' && o.key !== 'no-name') ? o.name + ' script' : o.name; };
    /* З чого зроблене оздоблення — за ключем варіанта: дві перлини, два
       стрази, перлина зі стразом у міксі, по одному в контурах. */
    var zxBits = function (k) {
      if (/no-custom/.test(k)) return [];
      if (/mix/.test(k)) return ['p', 'g'];
      var one = /rhinestone/.test(k) ? 'g' : 'p';
      return /full/.test(k) ? [one, one] : [one];
    };
    var zxCur = function (key) { return key === 'name' ? (zxNameOff ? ZX_NONAME : zxCfg.text.fonts[zxFont]) : zxSel[key]; };
    var zxApply = function (key, o) {
      if (key === 'name') {
        zxNameOff = o.key === 'no-name';
        zxNameBox.classList.toggle('is-off', zxNameOff);
        if (zxNameOff) return;
        zxFont = Math.max(0, zxCfg.text.fonts.indexOf(o));
        zxNameBox.style.setProperty('--gl-zx-font', "'GLZ " + o.key + "'");
        return;
      }
      zxSel[key] = o;
      var img = q('[data-gl-zx-layer="' + key + '"]', zx);
      if (!img) return;
      /* Картинку спершу розкодовуємо збоку і лише потім підставляємо: інакше
         браузер робить це в кадрі показу, і на дешевому телефоні кожна зміна
         образу давала помітний затин. Поки йде декодування, образ міг
         змінитись ще раз — тоді запізнілий результат викидаємо. */
      var url = zxUrl(o.asset);
      img.dataset.glWant = url;
      var put = function () {
        if (img.dataset.glWant !== url) return;
        img.removeAttribute('srcset');
        img.src = url;
        img.classList.remove('is-hot');
        void img.offsetWidth;
        img.classList.add('is-hot');
      };
      var pre = new Image();
      pre.src = url;
      if (pre.decode) pre.decode().then(put, put);
      else put();
    };
    /* Полоса підводиться до кнопки своєї зони, але тримається в межах
       стовпчика: вище його верху не піднімається і нижче низу не сходить,
       щоб не накрити рядок під ним. Носик показує, від якої саме кнопки. */
    var zxDecoFit = function (key) {
      var t = q('.gl-zx-tab[data-gl-zx-go="' + key + '"]', zx);
      if (!t) return;
      var lo = zxRow.offsetTop;
      var hi = Math.max(lo, lo + zxRow.offsetHeight - zxDeco.offsetHeight);
      var top = Math.min(Math.max(t.offsetTop, lo), hi);
      var tip = t.offsetTop + t.offsetHeight / 2 - top - 4.5;
      zxPick.style.setProperty('--zx-top', top + 'px');
      zxPick.style.setProperty('--zx-tip', Math.max(14, Math.min(tip, zxDeco.offsetHeight - 23)) + 'px');
    };
    var zxDecoShow = function (key) {
      var opts = zxOptsOf(key);
      if (!opts.length) return;
      if (key !== zxKey) {
        zxKey = key;
        zxDecoK.textContent = zxDeco.dataset[key === 'name' ? 'labelScript' : 'labelDecor'] || '';
        zxDecoRow.textContent = '';
        opts.forEach(function (o) {
          var b = document.createElement('button');
          b.type = 'button';
          var asFont = key === 'name' && o.key !== 'no-name';
          b.className = asFont ? 'gl-zx-dec gl-zx-dec--font' : 'gl-zx-dec';
          b.setAttribute('aria-pressed', 'false');
          var t = document.createElement('span');
          t.textContent = o.name;
          b.appendChild(t);
          if (key === 'name') {
            /* Назву шрифта пишемо ним самим */
            if (asFont) b.style.fontFamily = "'GLZ " + o.key + "', 'Newsreader', cursive";
          } else {
            var ic = document.createElement('span');
            ic.className = 'gl-zx-ic';
            zxBits(o.key).forEach(function (kind) {
              var d = document.createElement('span');
              d.className = kind === 'g' ? 'gl-zx-g' : 'gl-zx-p';
              ic.appendChild(d);
            });
            if (ic.firstChild) b.appendChild(ic);
          }
          b.addEventListener('click', function () {
            zxHold = true;
            clearInterval(zxTimer);
            zxTimer = null;
            zx.classList.add('is-picked');
            zxApply(key, o);
            zxMark(key, zxOptName(key, o));
            zxDecoShow(key);
            track('design_decor_selected', { zone: key, decor: o.key });
          });
          zxDecoRow.appendChild(b);
        });
        zxDecoRow.scrollLeft = 0;
      }
      var cur = zxCur(key);
      qa('.gl-zx-dec', zxDecoRow).forEach(function (b, i) {
        b.setAttribute('aria-pressed', String(opts[i] === cur));
      });
      zxDeco.classList.add('is-on');
      zxDecoFit(key);
    };
    /* ── Три готові образи ──
       Анімація показує три зібрані пари й більше нічого не перебирає.
       Раніше після кожного образу підсвічування бігло згори вниз по всіх
       зонах: кнопки перемикались, полоса оздоблення перемальовувалась —
       перед очима мерехтіло. Тепер образ вдягається цілком, а акцент стоїть
       на одній зоні: від початку це Swoosh, тож видно саме його оздоблення.
       Натиснули іншу зону — акцент лишається на ній.
       Число в кожному рядку — який варіант обрано, рахуючи від порожнього:
       1 = «No Custom» («No Name» для імені), далі як у полосі. */
    var ZX_LOOKS = [
      { swoosh: 6, tip: 5, quarter: 4, foxing: 1, backtab: 4, name: 1 },
      { swoosh: 2, tip: 5, quarter: 1, foxing: 1, backtab: 2, name: 1 },
      { swoosh: 3, tip: 3, quarter: 1, foxing: 1, backtab: 6, name: 1 }
    ];
    /* Скільки образ стоїть до зміни */
    var ZX_STEP = 2500;
    var ZX_FOCUS = 'swoosh';
    var zxLook = -1, zxRowN = 99, zxFocus = ZX_FOCUS;
    /* Вдягти образ цілком: усі шари одразу, без підсвічування */
    var zxWear = function (i) {
      var look = ZX_LOOKS[i];
      zxOrder.forEach(function (key) {
        var opts = zxOptsOf(key);
        if (!opts.length) return;
        var o = opts[Math.min(look[key] || 1, opts.length) - 1];
        if (o) zxApply(key, o);
      });
    };
    /* Підсвітити рядок стовпчика: кнопку, полосу варіантів і підпис */
    /* Світиться той елемент кросівка, чий рядок зараз підсвічено */
    var zxLit = function (key) {
      /* Клас знімаємо й ставимо заново — інакше блимання не перезапуститься */
      var lit = key === 'name' ? (zxNameOff ? null : zxNameBox) : q('[data-gl-zx-layer="' + key + '"]', zx);
      qa('.gl-zx-layer', zx).forEach(function (im) { im.classList.remove('is-lit'); });
      zxNameBox.classList.remove('is-lit');
      if (!lit) return;
      void lit.offsetWidth;
      lit.classList.add('is-lit');
    };
    var zxGo = function (key) {
      if (!zxCfg) return;
      var cur = zxCur(key);
      zxMark(key, cur ? zxOptName(key, cur) : '');
      zxLit(key);
      zxDecoShow(key);
    };
    /* Крок анімації: наступний образ. Акцент лишається на обраній зоні —
       її оздоблення видно весь час, спалах іде по її ж шару */
    var zxNext = function () {
      zxLook = (zxLook + 1) % ZX_LOOKS.length;
      zxWear(zxLook);
      zxGo(zxFocus);
    };
    var zxRun = function () {
      clearTimeout(zxTimer);
      zxTimer = null;
      if (zxHold || zxCalm || lite || !zxSeen || !zxCfg) return;
      zxTimer = setTimeout(function () { zxNext(); zxRun(); }, ZX_STEP);
    };
    /* Слабкий пристрій: образи не змінюються самі — декодувати п'ять шарів
       кожні дві з половиною секунди йому не під силу. Лишається тап. */
    liteOff.push(function () { clearTimeout(zxTimer); zxTimer = null; });
    /* Тап по кросівку (не по кнопці) — наступний образ */
    q('.gl-zx-shoe', zx).addEventListener('click', function (e) {
      if (!zxCfg || e.target.closest('[data-gl-zx-go]')) return;
      if (zxHold) { zxRowN = (zxRowN >= zxOrder.length ? 0 : zxRowN); zxGo(zxOrder[zxRowN % zxOrder.length]); zxRowN++; return; }
      zxNext();
      zxRun();
    });
    zxBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (!zxCfg) return;
        var key = b.dataset.glZxGo;
        zxRowN = Math.max(0, zxOrder.indexOf(key)) + 1;
        zxFocus = key;
        zxGo(key);
        zxRun();
        track('design_zone_selected', { zone: key });
      });
    });
    /* Кнопки міняють висоту разом із шириною екрана — прив'язку полоси
       перераховуємо, а на телефоні знімаємо зовсім */
    var zxFitT = null;
    onResize(function () {
      clearTimeout(zxFitT);
      zxFitT = setTimeout(function () { if (zxKey) zxDecoFit(zxKey); }, 150);
    });
    var zxLoad = function () {
      if (zxCfg || zxLoading) return;
      zxLoading = true;
      fetch(zx.dataset.config).then(function (r) { return r.json(); }).then(function (cfg) {
        zxCfg = cfg;
        cfg.zones.forEach(function (z) { zxSel[z.key] = z.options[0]; });
        zxOrder = cfg.zones.map(function (z) { return z.key; }).concat(['name']);
        var st = document.createElement('style');
        st.textContent = cfg.text.fonts.map(function (f) {
          return "@font-face{font-family:'GLZ " + f.key + "';src:url('" + zxUrl(f.asset) + "');font-display:swap;}";
        }).join('');
        document.head.appendChild(st);
        zxFont = -1;
        zxNameBox.style.setProperty('--gl-zx-font', "'GLZ " + cfg.text.fonts[0].key + "'");
        zxFont = 0;
        /* При «зменшеному русі» нічого не рухається, тож одразу вдягаємо
           перший образ і показуємо перший рядок — інакше вибору не видно */
        if (zxCalm) { zxLook = 0; zxWear(0); zxRowN = 1; zxGo(zxFocus); }
        if (zxSeen) { zxNext(); zxRun(); }
      }).catch(function () { zxLoading = false; });
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) zxLoad();
      }, { rootMargin: '400px 0px' }).observe(zx);
      new IntersectionObserver(function (entries) {
        var was = zxSeen;
        zxSeen = entries[0].isIntersecting;
        if (zxSeen && !was && zxCfg && zxLook === -1 && !zxHold) zxNext();
        zxRun();
      }, { threshold: 0.35 }).observe(q('.gl-zx-stage', zx));
    } else {
      zxSeen = true;
      zxLoad();
    }
  }

  /* ── Приводи у формі (телефон): рядок повільно їде по колу, поки не обрали ──
     Без копій: чип, що виїхав ліворуч, переноситься в кінець доріжки, тож
     обробники лишаються свої. Торкнулися чи обрали — рух зупиняється, рядок
     знову гортається пальцем з того самого місця. */
  var occRow = q('[data-gl-occasions]');
  var occTrack = q('[data-gl-occ-track]');
  if (occRow && occTrack && matchMedia('(max-width:719.98px)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var occOff = 0, occLast = 0, occRaf = 0, occSeen = false, occDone = false;
    /* Ширину чипів і відступ між ними міряємо не щокадру, а лише коли вони
       справді могли змінитися: на старті, коли прийшли шрифти, і на
       повороті екрана. Раніше кадр читав offsetWidth і getComputedStyle
       перед тим, як записати transform, — браузер мусив щоразу
       перераховувати верстку наново, і ця функція стала найдорожчою на
       сторінці: 209 мс за одну прокрутку при процесорі ×4. */
    var occGapPx = 7;
    var occMeasure = function () {
      occGapPx = parseFloat(getComputedStyle(occTrack).columnGap) || 7;
      Array.prototype.forEach.call(occTrack.children, function (c) { c.glStep = c.offsetWidth + occGapPx; });
    };
    var occFits = function () {
      var widest = 0, total = 0;
      Array.prototype.forEach.call(occTrack.children, function (c) {
        var step = c.glStep || 0;
        total += step;
        if (step - occGapPx > widest) widest = step - occGapPx;
      });
      return total > occRow.clientWidth + widest;
    };
    var occFrame = function (t) {
      occRaf = 0;
      if (occDone || !occSeen) { occLast = 0; return; }
      var dt = occLast ? Math.min((t - occLast) / 1000, 0.05) : 0;
      occLast = t;
      occOff -= 20 * dt;
      var first = occTrack.firstElementChild;
      var w = first.glStep || (first.offsetWidth + occGapPx);
      if (-occOff >= w) {
        occOff += w;
        occTrack.appendChild(first);
      }
      occTrack.style.transform = 'translate3d(' + occOff.toFixed(2) + 'px,0,0)';
      occRaf = requestAnimationFrame(occFrame);
    };
    var occStop = function () {
      if (occDone) return;
      occDone = true;
      if (occRaf) cancelAnimationFrame(occRaf);
      occTrack.style.transform = '';
      occRow.classList.remove('is-loop');
      occRow.scrollLeft = -occOff;
    };
    liteOff.push(occStop);
    onResize(function () { if (occStarted && !occDone) occMeasure(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (occStarted && !occDone) occMeasure(); });

    /* Вимір — аж тоді, коли рядок справді з'явився на екрані.
       Раніше він стояв у кадрі одразу після завантаження, і PageSpeed
       показав, що це найдорожче місце нашого скрипта: 34 мс. Причина не
       в самому читанні, а в тому, що воно змушує браузер обчислити
       верстку всієї сторінки саме тоді, коли та ще й не показана.
       Під час прокрутки верстка вже свіжа, і той самий вимір майже
       нічого не коштує.

       Клас is-loop ставимо теж тут: він міняє розкладку рядка, тож
       міряти треба вже з ним. Шрифти приходять пізніше й роблять чипи
       ширшими — після них міряємо ще раз, інакше рядок перескакував би. */
    var occStarted = false;
    var occStart = function () {
      if (occStarted) return;
      occStarted = true;
      occRow.classList.add('is-loop');
      occMeasure();
      /* Привід уже обрано (відновлена чернетка) — рядок не рухаємо */
      var occPicked = occTrack.querySelector('[aria-pressed="true"]');
      if (!occFits() || (occPicked && occPicked !== occTrack.firstElementChild)) {
        occStop();
        return;
      }
      occRow.addEventListener('pointerdown', occStop);
      occTrack.addEventListener('click', occStop);
    };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        occSeen = entries[0].isIntersecting;
        if (occSeen) occStart();
        if (occSeen && !occRaf && !occDone) occRaf = requestAnimationFrame(occFrame);
      }, { rootMargin: '200px 0px' }).observe(occRow);
    } else {
      occStart();
      occSeen = true;
      if (!occDone) occRaf = requestAnimationFrame(occFrame);
    }
  }


  paintCard();
  /* ── Головне фото: розмита заглушка → чітке фото ──
     Поки велике фото йде, видно його ж копію шириною 24px, розтягнуту й
     розмиту. Щойно браузер його розкодував — знімаємо заглушку й проявляємо
     оригінал. Якщо фото вже в кеші, is-ready стане одразу, без блимання. */
  var heroBox = q('.gl-hero-media');
  var heroImg = heroBox && q('picture img', heroBox);
  if (heroBox && heroImg) {
    var heroReady = function () { heroBox.classList.add('is-ready'); };
    if (heroImg.complete && heroImg.naturalWidth) heroReady();
    else {
      heroImg.addEventListener('load', heroReady);
      heroImg.addEventListener('error', heroReady);
      /* Підстраховка: якщо подія не прийшла (кеш, перерване з'єднання) — за
         6 секунд показуємо фото як є, щоб заглушка не лишилась назавжди */
      setTimeout(heroReady, 6000);
    }
  }

  paintPhone();

  /* ── Орієнтовна дата друкованої картки ──
     Рахуємо тут, а не в Liquid: Shopify віддає сторінку з кешу, і дата,
     вшита на сервері, через тиждень показувала б минуле. Скільки днів
     додати — у самому атрибуті (data-gl-eta="3"). Це строк лише для
     картки; кросівки мають свій, він у тексті четвертого кроку.
     Місяць пишемо скорочено англійською — сторінка англомовна. */
  qa('[data-gl-eta]').forEach(function (el) {
    var days = parseInt(el.getAttribute('data-gl-eta'), 10);
    if (!(days > 0)) days = 3;
    var d = new Date();
    d.setDate(d.getDate() + days);
    var txt;
    try {
      txt = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    } catch (e) {
      /* дуже старий браузер: без локалі, але з правильною датою */
      txt = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][d.getMonth()] + ' ' + d.getDate();
    }
    el.textContent = txt;
    el.setAttribute('datetime', d.toISOString().slice(0, 10));
  });

  track('landing_view');
})();
